if (!customElements.get('product-slider-thumbnails')) {
  /**
   *  @class
   *  @function ProductSliderThumbnails
   */
  class ProductSliderThumbnails extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.setupProductGallery);
    }

    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      this.init();
    }

    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.thumbnail_navigation_buttons = this.product_container.querySelectorAll('[data-thumbnail-scroll]');
      this.prev_button = this.product_container.querySelector('.custom-nav .custom-prev') || this.querySelector('.flickity-prev') || this.product_container.querySelector('.flickity-prev');
      this.next_button = this.product_container.querySelector('.custom-nav .custom-next') || this.querySelector('.flickity-next') || this.product_container.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }

init() {
      // 1. Check if Flickity is ready RIGHT NOW
      if (typeof Flickity !== 'undefined') {
        this.initializeFlickity();
      } else {
        // Fallback default while we wait for the network/files
        this.selectedIndex = 0; 
        
        // 2. If it's not ready, wait for the window to load
        window.addEventListener('load', () => {
          if (typeof Flickity !== 'undefined') {
            this.initializeFlickity();
          } else {
            console.error("Flickity failed to load entirely.");
          }
        });
      }

      // Start Gallery (This doesn't rely on Flickity, so it's safe here)
      this.setupProductGallery();
      this.setupThumbnailNavigation();
    }

    // This wrapper ensures everything relying on Flickity waits its turn
    initializeFlickity() {
      this.flkty = new Flickity(this, this.options);
      this.selectedIndex = this.flkty.selectedIndex;
      
      // Move this HERE so it never runs on an undefined object!
      this.setupEvents(); 
      this.syncActiveThumbnail();
    }

    setupThumbnailNavigation() {
      if (!this.thumbnail_navigation_buttons.length) return;

      this.thumbnail_navigation_buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const container = this.getThumbnailScrollContainer();
          if (!container) return;

          const direction = button.dataset.thumbnailScroll === 'next' ? 1 : -1;
          const firstThumbnail = Array.from(this.thumbnails).find((thumbnail) => thumbnail.offsetParent !== null);
          const scrollAmount = firstThumbnail
            ? firstThumbnail.getBoundingClientRect().width * 3
            : container.clientWidth * 0.75;

          container.scrollBy({
            left: direction * scrollAmount,
            behavior: 'smooth'
          });
        });
      });
    }

    reInit(imageSetIndex) {
      // Guard against trying to destroy a non-existent slider
      if (this.flkty && typeof this.flkty.destroy === 'function') {
        this.flkty.destroy();
      }

      this.setOptions();

      if (typeof Flickity !== 'undefined') {
        this.initializeFlickity();
      }
    }

    setupEvents() {
      // Guard against running setup if Flickity initialization failed or is delayed
      if (!this.flkty) return;

      const _this = this;
      
      if (this.prev_button) {
        const isExternalPrev = !this.contains(this.prev_button);
        if (isExternalPrev) {
          this.prev_button.addEventListener('click', (event) => {
            if (this.flkty) this.flkty.previous();
          });
          this.prev_button.addEventListener('keyup', (event) => {
            if (this.flkty) this.flkty.previous();
            event.preventDefault();
          });
        } else {
          let prev = this.prev_button.cloneNode(true);
          this.prev_button.parentNode.append(prev);
          this.prev_button.remove();
          prev.addEventListener('click', (event) => {
            if (this.flkty) this.flkty.previous();
          });
          prev.addEventListener('keyup', (event) => {
            if (this.flkty) this.flkty.previous();
            event.preventDefault();
          });
        }
      }

      if (this.next_button) {
        const isExternalNext = !this.contains(this.next_button);
        if (isExternalNext) {
          this.next_button.addEventListener('click', (event) => {
            if (this.flkty) this.flkty.next();
          });
          this.next_button.addEventListener('keyup', (event) => {
            if (this.flkty) this.flkty.next();
            event.preventDefault();
          });
        } else {
          let next = this.next_button.cloneNode(true);
          this.next_button.parentNode.append(next);
          this.next_button.remove();
          next.addEventListener('click', (event) => {
            if (this.flkty) this.flkty.next();
          });
          next.addEventListener('keyup', (event) => {
            if (this.flkty) this.flkty.next();
            event.preventDefault();
          });
        }
      }

      this.video_containers.forEach((container) => {
        const btn = container.querySelector('button');
        if (btn) {
          btn.addEventListener('click', function () {
            container.setAttribute('hidden', '');
          });
        }
      });

      if (this.flkty && typeof this.flkty.on === 'function') {
        this.flkty.on('settle', function (index) {
          _this.selectedIndex = index;
        });
      }

      this.flkty.on('change', (index) => {
        // Safety check to ensure cells are populated
        if (!this.flkty.cells || !this.flkty.cells[_this.selectedIndex]) return;

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        
        if (active_thumb) {
          active_thumb.classList.add('is-initial-selected');
          this.syncActiveThumbnail(active_thumb);
        }

        // Stop previous video
        if (previous_media) {
          if (previous_media.classList.contains('product-single__media-external-video')) {
            const iframe = previous_media.querySelector('iframe');
            if (iframe && iframe.contentWindow) {
              if (previous_media.dataset.provider === 'youtube') {
                iframe.contentWindow.postMessage(JSON.stringify({
                  event: "command",
                  func: "pauseVideo",
                  args: ""
                }), "*");
              } else if (previous_media.dataset.provider === 'vimeo') {
                iframe.contentWindow.postMessage(JSON.stringify({
                  method: "pause"
                }), "*");
              }
            }
            const playBtn = previous_media.querySelector('.product-single__media-external-video--play');
            if (playBtn) playBtn.removeAttribute('hidden');
          } else if (previous_media.classList.contains('product-single__media-native-video')) {
            const video = previous_media.querySelector('video');
            if (video) video.pause();
          }
        }
      });

      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
        this.syncActiveThumbnail();
      });
    }

    thumbnailClick(thumbnail, index) {
      if (!this.flkty) return;
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.syncActiveThumbnail(thumbnail);
      this.flkty.select(index);
    }

    syncActiveThumbnail(activeThumb = null) {
      if (!this.thumbnail_container) return;

      const targetThumb = activeThumb || this.thumbnail_container.querySelector('.product-thumbnail.is-initial-selected');
      if (!targetThumb || targetThumb.offsetParent === null) return;

      requestAnimationFrame(() => {
        const container = this.getThumbnailScrollContainer();
        if (!container) return;

        const containerRect = container.getBoundingClientRect();
        const thumbRect = targetThumb.getBoundingClientRect();
        const canScrollHorizontally = container.scrollWidth > container.clientWidth + 1;
        const canScrollVertically = container.scrollHeight > container.clientHeight + 1;
        const targetLeft = canScrollHorizontally
          ? container.scrollLeft + (thumbRect.left - containerRect.left) - (container.clientWidth - thumbRect.width) / 2
          : container.scrollLeft;
        const targetTop = canScrollVertically
          ? container.scrollTop + (thumbRect.top - containerRect.top) - (container.clientHeight - thumbRect.height) / 2
          : container.scrollTop;

        container.scrollTo({
          left: Math.max(0, targetLeft),
          top: Math.max(0, targetTop),
          behavior: 'smooth'
        });
      });
    }

    getThumbnailScrollContainer() {
      let node = this.thumbnail_container;

      while (node) {
        if (node.scrollWidth > node.clientWidth + 1 || node.scrollHeight > node.clientHeight + 1) {
          return node;
        }
        node = node.parentElement;
      }

      return this.thumbnail_container;
    }

    setDraggable(draggable) {
      if (!this.flkty) return;
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }

    selectCell(mediaId) {
      if (!this.flkty) return;
      this.flkty.selectCell(mediaId);
    }

    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }

    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);
        let activelink = item.querySelector('.product-single__media-zoom');
        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }

    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail ? thumbnail.getBoundingClientRect() : { left: 0, top: 0, width: 0 };
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };

      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }

    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider-thumbnails', ProductSliderThumbnails);
}
